"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollQuestionTag = void 0;
/**
 * Question tag is used for classifying questions.
 */
exports.PollQuestionTag = {
    Gad2: 'gad-2',
    Gad7: 'gad-7',
    Phq2: 'phq-2',
    Phq9: 'phq-9',
};
//# sourceMappingURL=poll-question-tag.js.map